import * as $ from "jquery";
import { throttle } from "throttle-debounce";

function BackToTop() {
	let $backToTop = $('.back-to-top');
	let $window = $(window);
	let windowVH = $window.innerHeight();

	$window.on("scroll", function () {
		throttle( 150, $backToTop.toggleClass("state-visible", $(this).scrollTop() > windowVH) );
	}).on("resize", function () {
		throttle( 150, windowVH = $(this).height() );
	});

	$('.js-back-to-top').on('click', function () {
		$("html, body").animate({ scrollTop: 0 }, 600);
		return false;
	});
}

export function init() {
	BackToTop();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/backToTop.ts